import React, { useState, useEffect, useRef } from "react";
import { Menubar } from "primereact/menubar";
import { Button } from "primereact/button";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import "./Navbar.css";
import { Link, useNavigate } from "react-router-dom";
import AuthService from "../AuthContext/AuthService";

export default function Navbar({ onSidebarToggle }) {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const toast = useRef(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogout = () => {
    AuthService.logout();
    toast.current.show({
      severity: "success",
      summary: "Success",
      detail: "Logged out successfully",
      life: 3000,
    });
    navigate("/");
    window.location.reload();
  };

  const confirmLogout = () => {
    confirmDialog({
      message: "Are you sure you want to logout?",
      header: "Logout Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: handleLogout,
      acceptClassName: "custom-accept-button",
      rejectClassName: "custom-reject-button",
    });
  };

  const start = (
    <div className="navbar-left">
      <Link to="/">
        <img
          src="/img/majesteye-icon-skeye-form-horizontal-white-background.svg"
          alt="SkeyeForm Logo"
          className="navbar-logo"
          style={{ width: "160px" }}
        />
      </Link>
      <Button
        icon="pi pi-bars"
        className="sidebar-toggle-button p-button-rounded"
        onClick={onSidebarToggle}
      />
    </div>
  );

  const end = (
    <div className="navbar-right">
      {!isMobile && (
        <div className="navbar-item-container">
          <Button
            className="navbar-item"
            severity="secondary"
            text
            label={
              <>
                <span style={{ marginRight: "8px" }}>Logout</span>
                <i className="pi pi-sign-out navbar-icon" />
              </>
            }
            onClick={confirmLogout}
          />
        </div>
      )}
    </div>
  );

  return (
    <div className="card navbar">
      <Menubar
        start={start}
        end={end}
        style={{
          backgroundColor: "#fff",
          borderRadius: "none !important",
        }}
      />
      <ConfirmDialog />
      <Toast ref={toast} />
    </div>
  );
}
